export const MEDICE_GROUPS = ['medice_staff', 'medice-staff-medice', 'medice-staff-non-medice'];
export const MEDICE_STAFF_IDS = [
    '8155d108fbe34b91820e7c0555078435',
    '3a70987384444659952af1e3084bd42c',
    '94087cd252884f8cb29f370162855ee9'
];
